/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const Ribbon = ({ fill, fillOpacity, size = 20, stroke, ...rest }: IconProps) => {
  const { colors } = useTheme()

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 14 20"
      width={size * 0.7}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1 3C1 1.89543 1.89543 1 3 1H11C12.1046 1 13 1.89543 13 3V19L7 13L1 19V3Z"
        fill={fill ?? colors.text}
        fillOpacity={fillOpacity ?? '0.4'}
        stroke={stroke ?? colors.backgroundLight}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
